define(["../templateFactoryModule", "angular"], function (templateFactoryModule) {
    "use strict";

    return templateFactoryModule.directive("templateFactoryLimitLength", ["sanitizeService", function (sanitizeService) {
        return {
            restrict: "E",
            template: "<span translate class='preserve-white-spaces' ng-attr-title='{{::toTitle(value)}}'>{{::limitLength(value)}}</span>",
            scope: {
                value: "@"
            },
            controller: ["$scope", function ($scope) {
                $scope.toTitle = function (value) {
                    var sanitize = sanitizeService(value);
                    return isTooBig(sanitize)
                        ? sanitize
                        : "";
                };

                $scope.limitLength = function (value) {
                    var sanitize = sanitizeService(value);
                    return isTooBig(sanitize)
                        ? sanitize.substr(0, 297) + "..."
                        : sanitize;
                };

                function isTooBig(value) {
                    return typeof value === "string" && value.length > 300;
                }


            }]
        };
    }]);
});